<template>
  <div class="pa-4">
    <h2 class="mb-3 text-center">
      {{ $t('servicesystem.loginform.text.set_new_pw') }}
    </h2>
    <!-- 
    <p class="text-center"
      v-html="'The new password applies to all Qwips Service System login portals for the <b>' + email + '</b>  account.'" />
    -->
    <v-card class="pa-2 mb-4" outlined>
      <v-row no-gutters class="mb-1" style="cursor: pointer;" @click="showcriteria = !showcriteria">
        <v-col cols="0">
          <p class="mb-0" :class="valid ? 'success--text' : ''">
            <v-icon size="14" class="mr-1" style="margin-bottom: 2px; color: inherit;">
              {{ valid ? 'mdi-check' : 'mdi-information' }}
            </v-icon>
            <b style="color: inherit;">
              {{ $t('servicesystem.loginform.text.password_criteria') }}
            </b>
          </p>
        </v-col>
        <v-col cols="auto">
          <v-btn icon x-small class="my-n2">
            <v-icon v-text="!showcriteria ? 'mdi-chevron-down' : 'mdi-chevron-up'" size="20"></v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <template v-if="showcriteria">
        <RuleBulletPoint v-for="(rule, index) in passwordRules" :key="index" :rule="rule" :value="passwordComputed">
        </RuleBulletPoint>
        <RuleBulletPoint :rule="passwordConfirmationRule" :value="passwordconfirm">
        </RuleBulletPoint>
      </template>
    </v-card>

    <p v-if="errorText" class="error--text text-center">{{ errorText }}</p>

    <v-form v-model="valid" ref="form">
      <v-row no-gutters>
        <v-text-field ref="passwordfield" :label="$t('servicesystem.loginform.text.new_pw')" v-model="passwordComputed"
          min="6" :append-icon="!showpw ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (showpw = !showpw)"
          :type="!showpw ? 'password' : 'text'" :rules="[requiredRule, ...passwordRules]" counter clearable
          v-on:keyup.enter="focusConfirm()">
        </v-text-field>
      </v-row>
      <v-row no-gutters>
        <v-text-field ref="passwordconfirmfield" :label="$t('servicesystem.loginform.text.new_pw_confirm')"
          v-model="passwordconfirm" min="6" :append-icon="!showpwc ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (showpwc = !showpwc)" :type="!showpwc ? 'password' : 'text'"
          :rules="[requiredRule, passwordConfirmationRule]" class="pt-2" counter clearable
          v-on:keyup.enter="focusSubmit()">
        </v-text-field>
      </v-row>
    </v-form>

    <WideBtn :text="$t('servicesystem.loginform.text.set_pw')" color="var(--v-primary-base)" :disabled="!valid"
      :loading="taskInProgress" @click="setPW()">
    </WideBtn>
    <WideBtn :text="$t('servicesystem.common_objects.commonterms.cancel')" color="var(--v-primary-base)"
      :disabled="taskInProgress" :filled="false" @click="$emit('cancel')">
    </WideBtn>

    <v-snackbar v-model="snackbar" :color="success ? 'green' : 'error'">{{ snackbarText }}</v-snackbar>
  </div>
</template>


<script>
import http from "@/api/client";
import WideBtn from "@/components/WideBtn.vue";
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";
import RuleBulletPoint from "./RuleBulletPoint.vue";

export default {
  name: "SetPwForm",
  model: {
    prop: "password",
    event: "change",
  },
  props: {
    email: String,
    otp: [String, Number],
    password: String,
  },
  components: {
    WideBtn,
    RuleBulletPoint
  },
  mixins: [QInputRuleMixin],

  data() {
    return {
      valid: false,
      showcriteria: 'default',
      showpw: false,
      showpwc: false,
      passwordconfirm: null,


      taskInProgress: false,
      success: false,
      errorText: "",

      snackbar: false,
      snackbarText: "",
    };
  },

  methods: {
    focusConfirm() {
      this.$refs.passwordconfirmfield.focus();
    },
    focusSubmit() {
      this.$refs.form.validate();
      if (this.valid) {
        this.setPW();
      }
    },

    setPW() {
      this.onStart();
      var meta = { clientApiMethod: 'ChangePassword', input: { email: this.email } };
      http()
        .post("/api2/Accounts/ChangePassword", { Email: this.email, Code: this.otp, Password: this.passwordComputed }, meta)
        .then((response) => {
          if (response.data.Success) {
            this.$emit("next");
          }
          else {
            this.passwordErrorText = response.data.Message;
            this.onError(response.data.Message, 'Invalid code');
          }
        })
        .catch((error) => {
          this.onError(error, error.data.Message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onStart() {
      this.taskInProgress = true;
      this.success = true;
      this.snackbar = false;
      this.errorText = "";
    },

    onError(error, snacktext) {
      console.error('onError', error);
      this.errorText = snacktext;
      this.success = false;
      this.snackbarText = snacktext;
      this.snackbar = true;
      this.taskInProgress = false;
    },
  },

  computed: {
    passwordConfirmationRule() {
      return (val) => this.passwordComputed == val || this.$t('servicesystem.loginform.text.confirm_pw_match');
    },

    passwordComputed: {
      get() {
        return this.password;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },

  watch: {
    valid() {
      //just to collapse the criteria list if all the requirements are met
      if (this.valid && this.password && this.showcriteria === 'default') {
        //console.log('hide criteria');
        this.showcriteria = false;
      }
    }
  },
};
</script>


<style lang="scss"></style>